module.exports = __webpack_public_path__ + "img/pacman.cb59d1ee.png";